import type { RelationId, RelationUpdateRequest } from '@domains/subscription/priv/Relations/api/api'
import { RelationEditor } from '@domains/subscription/priv/Relations/components/RelationEditor'
import { RelationDetails } from '@domains/subscription/priv/Relations/usecases/RelationDetails'
import { createRoute } from '@domains/subscription/router/router'
import { useNavigate, useParams } from 'react-router-dom'
import { useRelation, useRelations, useRelationTemplates, useUpdateRelation } from '../api/queries'
import { RelationsList } from '../usecases/RelationsList'

export const RelationsListFactory = () => {
  const { data: relations = [] } = useRelations()
  const navigate = useNavigate()

  const handleClickRelation = (relationId: string): void => {
    navigate(relationId)
  }

  return <RelationsList relations={relations} onClickRelation={handleClickRelation} />
}

export const RelationDetailsRoute = () => {
  const { relationId } = useParams<{ relationId: RelationId }>()
  const relation = useRelation(relationId)
  const templates = useRelationTemplates()
  const { mutateAsync: updateRelation, isLoading: isSavingChanges } = useUpdateRelation(relationId!)
  const navigate = useNavigate()

  const navigator = {
    back: () => {
      navigate(createRoute.relations())
    },
  }

  const handleSaveChanges = async (changeRequests: RelationUpdateRequest[]) => {
    await updateRelation(changeRequests)
  }

  if (!relationId) return null

  const isLoading = relation.isLoading || templates.isLoading || relation.isFetching || templates.isFetching || isSavingChanges

  return (
    <RelationDetails
      relation={relation.data}
      templates={templates.data}
      isLoading={isLoading}
      navigator={navigator}
      onSaveChanges={handleSaveChanges}
      slots={{ Editor: RelationEditor }}
    />
  )
}
